import React from 'react';
import styles from './headings.module.scss';

type HeadingsProps = {
  children: React.ReactNode
};

/**
 * Headings
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
export const H1: React.FC<HeadingsProps> = ({ children }) => <div className={styles.h1}>{children}</div>
export const H2: React.FC<HeadingsProps> = ({ children }) => <div className={styles.h2}>{children}</div>
export const H3: React.FC<HeadingsProps> = ({ children }) => <div className={styles.h3}>{children}</div>
export const H4: React.FC<HeadingsProps> = ({ children }) => <div className={styles.h4}>{children}</div>
export const H5: React.FC<HeadingsProps> = ({ children }) => <div className={styles.h5}>{children}</div>
export const H6: React.FC<HeadingsProps> = ({ children }) => <div className={styles.h6}>{children}</div>
export const StatHeading: React.FC<HeadingsProps> = ({ children }) => <div className={styles.statHeading}>{children}</div>